export const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString; // fallback if invalid
    return date.toLocaleDateString('en-GB'); // en-GB uses dd/mm/yyyy
};

// ✅ CORRECT: returns "2025-02-01"
export const OHformatDate = (date) => {
  if (!date) return '';
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};
export const formatHoursAsDays = (hours) => {
  if (!hours || hours <= 0) return 0;

  const fullDays = Math.floor(hours / 8);
  const remainingHours = hours % 8;

  if (remainingHours === 0) {
    return fullDays === 1 ? 1 : `${fullDays}`;
  }

  // Format partial day: e.g., "1.5 days", "0.25 days"
  const totalDays = hours / 8;
  const roundedDays = Math.round(totalDays * 100) / 100; // Round to 2 decimals

  return `${roundedDays}`;
};

export const formatLatenessHours = (hours) => {
  if (!hours || hours <= 0) return '0 min';
  if (hours >= 1) return `${hours.toFixed(1)} hrs`;
  return `${Math.round(hours * 60)} min`;
};

export const formatDateForDisplay = (dateString) => {
    if (!dateString) return 'N/A';
    const [year, month, day] = dateString.split('-');
    return `${day}/${month}/${year}`;
  };

// helper.js or inside your component file
export const groupConsecutiveDates = (dateStrings) => {
  if (!dateStrings || dateStrings.length === 0) return [];

  // Parse and sort dates
  const dates = dateStrings
    .map(d => new Date(d))
    .sort((a, b) => a - b);

  const groups = [];
  let currentGroup = [dates[0]];

  for (let i = 1; i < dates.length; i++) {
    const prevDate = currentGroup[currentGroup.length - 1];
    const currDate = dates[i];

    // Check if current date is the next day after prevDate
    const nextDay = new Date(prevDate);
    nextDay.setDate(nextDay.getDate() + 1);

    if (currDate.getTime() === nextDay.getTime()) {
      currentGroup.push(currDate);
    } else {
      groups.push([...currentGroup]);
      currentGroup = [currDate];
    }
  }
  groups.push(currentGroup);

  // Format each group
  return groups.map(group => {
    if (group.length === 1) {
      return formatDateForDisplay(group[0].toISOString().split('T')[0]);
    } else {
      const start = formatDateForDisplay(group[0].toISOString().split('T')[0]);
      const end = formatDateForDisplay(group[group.length - 1].toISOString().split('T')[0]);
      return `${start} – ${end}`;
    }
  });
};